import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';

export const ImagePreviewDialog = ({ open, onClose, imageUrl, alt }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    BackdropProps={{
      sx: {
        backgroundColor: 'rgba(0, 0, 0, 0.7)', // adjust opacity here
      },
    }}
    fullWidth
  >
    <DialogContent sx={{ position: 'relative', padding: 0 }}>
      <IconButton aria-label="close" onClick={onClose} sx={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }}>
        <CloseIcon />
      </IconButton>
      <Box
        component="img"
        src={imageUrl}
        alt={alt}
        sx={{
          width: '100%',
          height: 'auto',
          display: 'block',
        }}
      />
    </DialogContent>
  </Dialog>
);
